import * as React from 'react';
import type {
  Filters,
  PaginationControl,
} from 'hooks/store/trips/use-trips-tracking-search-params';
import type { Trip } from 'contracts/tracking-v2/trips';
import type { Pagination } from 'contracts/Pagination';
import { api, applyQueryString, handleApiError } from 'services/api';

type Payload = {
  filters?: Filters;
  pagination?: PaginationControl
}

type Response = {
  data: Trip[];
  meta: Pagination;
}

export const useFetchPaginatedTrips = () => {
  const fetchPaginatedTrips = React.useCallback(async (payload: Payload) => {
    const url = applyQueryString('/tracking-v2/trips', {
      ...payload.filters,
      ...payload.pagination,
    });

    try {
      const { data } = await api.get<Response>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchPaginatedTrips
  };
};